
const contexts = new Map();

function add(url, context) {
  contexts.set(url, context);
};

module.exports = {
    add,
    contexts,
  };
